import React, { useState } from 'react';
import './ElementsList.css';

const ElementsList = ({ elements, setElements, language }) => {
  const [newElement, setNewElement] = useState({ texte: '', couleur: '#3498db' });
  const [editingElement, setEditingElement] = useState(null);
  
  // Traductions pour les textes de l'interface
  const translations = {
    fr: {
      createElement: 'Créer un élément',
      editElement: 'Modifier un élément',
      elementName: 'Nom de l\'élément',
      elementColor: 'Couleur',
      saveButton: 'Enregistrer',
      cancelButton: 'Annuler',
      createButton: 'Créer',
      editButton: 'Modifier',
      deleteButton: 'Supprimer',
      noElements: 'Aucun élément créé. Ajoutez votre premier élément!'
    },
    en: {
      createElement: 'Create element',
      editElement: 'Edit element',
      elementName: 'Element name',
      elementColor: 'Color',
      saveButton: 'Save',
      cancelButton: 'Cancel',
      createButton: 'Create',
      editButton: 'Edit',
      deleteButton: 'Delete',
      noElements: 'No elements created. Add your first element!'
    }
  };
  
  const t = translations[language];
  
  // Gestion de la soumission du formulaire
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (newElement.texte.trim() === '') return;
    
    if (editingElement !== null) {
      // Mode édition: mise à jour d'un élément existant
      const updatedElements = elements.map((element) => 
        element.id === editingElement ? { ...element, ...newElement } : element
      );
      setElements(updatedElements);
      setEditingElement(null);
    } else {
      // Mode création: ajout d'un nouvel élément
      const id = Date.now().toString();
      setElements([...elements, { id, ...newElement }]);
    }
    
    // Réinitialisation du formulaire
    setNewElement({ texte: '', couleur: '#3498db' });
  };
  
  // Gestion de l'édition d'un élément
  const handleEdit = (element) => {
    setNewElement({ texte: element.texte, couleur: element.couleur });
    setEditingElement(element.id);
  };
  
  // Gestion de la suppression d'un élément
  const handleDelete = (elementId) => {
    const updatedElements = elements.filter(element => element.id !== elementId);
    setElements(updatedElements);
    
    if (editingElement === elementId) {
      setEditingElement(null);
      setNewElement({ texte: '', couleur: '#3498db' });
    }
  };
  
  // Annulation de l'édition
  const handleCancel = () => {
    setEditingElement(null);
    setNewElement({ texte: '', couleur: '#3498db' });
  };

  return (
    <div className="elements-list-container">
      <div className="elements-form">
        <h2>{editingElement !== null ? t.editElement : t.createElement}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="element-text">{t.elementName}</label>
            <input
              id="element-text"
              type="text"
              value={newElement.texte}
              onChange={(e) => setNewElement({ ...newElement, texte: e.target.value })}
              placeholder={t.elementName}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="element-color">{t.elementColor}</label>
            <div className="color-selector">
              <input
                id="element-color"
                type="color"
                value={newElement.couleur}
                onChange={(e) => setNewElement({ ...newElement, couleur: e.target.value })}
              />
              <input
                type="text"
                value={newElement.couleur}
                onChange={(e) => setNewElement({ ...newElement, couleur: e.target.value })}
                placeholder="#RRGGBB"
              />
            </div>
          </div>
          
          <div className="form-buttons">
            {editingElement !== null && (
              <button type="button" onClick={handleCancel} className="cancel-button">
                {t.cancelButton}
              </button>
            )}
            <button type="submit" className="submit-button">
              {editingElement !== null ? t.saveButton : t.createButton}
            </button>
          </div>
        </form>
      </div>
      
      <div className="elements-list">
        <h2>{elements.length > 0 ? `${elements.length} ${elements.length === 1 ? 'élément' : 'éléments'}` : ''}</h2>
        
        {elements.length === 0 ? (
          <p className="no-elements">{t.noElements}</p>
        ) : (
          <ul>
            {elements.map((element) => (
              <li key={element.id} className="element-item">
                <div className="element-color-indicator" style={{ backgroundColor: element.couleur }}></div>
                <span className="element-text">{element.texte}</span>
                <div className="element-actions">
                  <button 
                    className="edit-button" 
                    onClick={() => handleEdit(element)}
                    aria-label={t.editButton}
                  >
                    ✏️
                  </button>
                  <button 
                    className="delete-button" 
                    onClick={() => handleDelete(element.id)}
                    aria-label={t.deleteButton}
                  >
                    🗑️
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ElementsList;